import React from 'react'
import { useState, useRef, useEffect } from 'react'
import '../components-css/portfolio-page.scss'
import ArrowIcon from '../assets/svgs/Group 3.svg';
import GradientArrowIcon from '../assets/svgs/Group 3 (5).svg'
import Project1 from '../pngs/Mask group (1).png'
import CaseStudy from '../components/CaseStudy';
import caseStudyImage from "../pngs/Rectangle 54.png";
import '../components-css/case-study-page.scss'
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../config';
import { Helmet } from 'react-helmet-async';
import Loader from '../components/loader';

const CaseStudyPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);
    const [isPageReady, setIsPageReady] = useState(false);
    const [contentData, setCasestudyData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [loadedImages, setLoadedImages] = useState({});
    const allImagesLoaded = useRef(false);

    // Once all images are loaded, restore scroll position
    // useEffect(() => {
    //     if (isLoading || contentData.length === 0) return;

    //     const savedScroll = sessionStorage.getItem('caseStudyScrollPosition');
    //     if (!savedScroll) {
    //         window.scrollTo(0, 0);
    //         return;
    //     }

    //     const totalImages = contentData.length;
    //     const loadedCount = Object.keys(loadedImages).length;

    //     if (loadedCount >= totalImages && !allImagesLoaded.current) {
    //         allImagesLoaded.current = true;
    //         window.scrollTo(0, parseInt(savedScroll));
    //         sessionStorage.removeItem('caseStudyScrollPosition');
    //     }
    // }, [loadedImages, isLoading, contentData]);
    

    useEffect(() => {
        getCasestudyData()
    }, [])

    const getCasestudyData = async () => {
        try {
            let response = await axios.get(`${BASE_URL}/casestudy`)
            setCasestudyData(response.data.data)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    }

    const handleImageLoad = (index) => {
        setLoadedImages(prev => ({ ...prev, [index]: true }));
    }

    const handleViewCaseStudy = (id) => {
        sessionStorage.setItem('caseStudyScrollPosition', window.scrollY);
        navigate(`/case-study/${id}`);
    }

    // if (!isPageReady && !isLoading) {
    //     return null; // renders blank page
    // 

    if (isLoading) return <Loader />;
    // if (!isPageReady) return null;

    return (
        <>
            <div className='portfolio-page-container'>
                <Helmet>
                    <title>Omka Tech Case Studies | IT, Web & App Project Results</title>
                    <meta name="description" content="Explore Omka Tech's case studies on IT services, mobile app development, website projects, and digital marketing solutions for global Clients" />
                    <link rel="canonical" href="https://omkatech.com/case-study" />
                </Helmet>
                <div className="portfolio-heading">
                    <h1>Client Case Studies & Results</h1>
                    <p>Explore how our innovative solutions have driven success for businesses across industries.</p>
                </div>
            </div>
            {isLoading ? (
                <Loader />
            ) : (
                <div className="case-study-container d-flex">
                    {contentData?.map((contentData, index) => (
                        <div className={`case-study-inner ${index % 2 === 0 ? 'even' : 'odd'}`}>
                            <div className="content-container left">
                                <h2 className='title'>{contentData?.title}</h2>
                                <span className='case-study-subtitle'>{contentData?.sub_title}</span>

                                <div className="app-details">
                                    <div className="results">
                                        <h2>Technology</h2>
                                        <span>{contentData?.technology}</span>
                                    </div>
                                    <div className="users">
                                        <h2>Industry</h2>
                                        <span>{contentData?.industry}</span>
                                    </div>
                                </div>
                                <div className="button">
                                    <button onClick={() => handleViewCaseStudy(contentData?.id)} className="btn-bg" onMouseEnter={() => setIsHovered(true)}
                                        onMouseLeave={() => setIsHovered(false)}>
                                        <span>VIEW CASE STUDY</span> <span className='img'>
                                            {isHovered ? (
                                                <img src={GradientArrowIcon} alt="gradient-icon" />
                                            ) : (
                                                <img src={ArrowIcon} alt="arrow-icon" />
                                            )}
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div className="image-container right">
                                {!loadedImages[index] && (
                                    <div className="shimmer-placeholder" />
                                )}
                                <img
                                    src={`${contentData?.home_page_image_path}${contentData?.home_page_image}`}
                                    alt="image"
                                    onLoad={() => handleImageLoad(index)}
                                    style={{ display: loadedImages[index] ? 'block' : 'none' }}
                                />
                            </div>
                            <div className="button show-in-mobile">
                                <button onClick={() => handleViewCaseStudy(contentData?.id)} className="btn-bg" onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}>
                                    <span>VIEW CASE STUDY</span> <span className='img'>
                                        {isHovered ? (
                                            <img src={GradientArrowIcon} alt="gradient-icon" />
                                        ) : (
                                            <img src={ArrowIcon} alt="arrow-icon" />
                                        )}
                                    </span>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}

export default CaseStudyPage